import { FC } from "react";
import { Href, useSegments } from "expo-router";

import { VnIcon } from "@/components/VnIcon";
import {
  VnSidebar,
  VnSidebarContent,
  VnSidebarFooter,
  VnSidebarHeader,
  VnSidebarMenu,
  VnSidebarMenuButton,
  VnSidebarMenuItem,
} from "@/components/VnSidebar";
import { VnText } from "@/components/VnText/VnText";
import { SidebarItemType } from "@/domain/sidebar";
import { LogoutSidebarIcon } from "@/theme/icons/LogoutSidebarIcon";
import { cn } from "@/utils/tailwind";

import { AppHeader } from "./AppHeader";

type AppSidebarPropsType = {
  items: SidebarItemType[];
};

export const AppSidebar: FC<AppSidebarPropsType> = ({ items }) => {
  const segments = useSegments();

  const isActive = (href: Href) => {
    const hrefPath = typeof href === "string" ? href : href.pathname;
    const routePath = hrefPath?.startsWith("/")
      ? hrefPath.substring(1)
      : hrefPath;

    return segments.join("/") === routePath;
  };

  const getItemKey = (href: Href, index: number) => {
    if (typeof href === "string") {
      return href;
    }
    return href.pathname ?? index.toString();
  };

  return (
    <VnSidebar>
      <VnSidebarHeader>
        <AppHeader />
      </VnSidebarHeader>

      <VnSidebarContent className="px-2">
        <VnSidebarMenu>
          {items.map((item, index) => (
            <VnSidebarMenuItem key={getItemKey(item.href, index)}>
              <VnSidebarMenuButton
                href={item.href}
                isActive={isActive(item.href)}
                analyticsLabel={item.i18nKey}
                className="px-3">
                {isActive(item.href) ? item.ActiveIcon : item.InactiveIcon}
                <VnText
                  variant={isActive(item.href) ? "lgMedium" : "lg"}
                  i18nKey={item.i18nKey}
                  className={cn("text-secondary", {
                    "text-sidebar": isActive(item.href),
                  })}
                />
              </VnSidebarMenuButton>
            </VnSidebarMenuItem>
          ))}
        </VnSidebarMenu>
      </VnSidebarContent>

      <VnSidebarFooter>
        <VnSidebarMenuButton
          href="/logout"
          analyticsLabel="native:appMenu.logout">
          <VnIcon as={LogoutSidebarIcon} className="text-card" size={20} />
          <VnText
            variant="lg"
            i18nKey="native:appMenu.logout"
            className="text-card"
          />
        </VnSidebarMenuButton>
      </VnSidebarFooter>
    </VnSidebar>
  );
};
